<template>
  <div class="records-box">
    <h4 class="records-title flex-between" v-if="!isMobile">
      <span>最新区块</span>
      <router-link to="/block">查看全部</router-link>
    </h4>
    <div v-for="blockinfo in blockList" :key="blockinfo.id" class="record-item">
      <div class="record-title flex-between">
        <div>
          区块高度：
          <router-link :to="blockinfo.id | blockDetail" class="numtext">{{blockinfo.id}}</router-link>
        </div>
        <div v-show="blockinfo.timestamp">
          时间：
          <span class="numtext">{{blockinfo.timestamp | fulltime}}</span>
        </div>
      </div>
      <div  class="record-content flex-center">
        <!-- <div class="record-col address">
          <p>挖矿地址</p>
          <p>
            <placeholder v-if="!blockinfo.miner" :width="160" :height="18"/>
            <router-link
              v-else
              :to="blockinfo.miner | addressDetail"
            >{{blockinfo.miner | addressEll}}</router-link>
          </p>
        </div> -->
        <div class="record-col">
          <p>交易数</p>
          <p>
            <span class="num">{{blockinfo.transactions_count}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Placeholder from "@/components/Placeholder.vue";
import display from "@/mixins/display.js";
export default {
  props: ["blockList"],
  mixins: [display],
  components: {
    placeholder: Placeholder
  }
};
</script>
